/* eslint-disable react-native/sort-styles */
import { StyleSheet, TextStyle } from "react-native";
import { kColors } from "./kColors";

const kFontsObj = {
  title: {
    fontSize: 22,
  },
  body: {
    fontFamily: "Poppins",
    fontWeight: "300",
    fontSize: 14,
  },
  bodySmall: {
    fontFamily: "Poppins",
    fontWeight: "300",
    fontSize: 9,
  },
  bodyItalic: {
    fontFamily: "Poppins",
    fontWeight: "300",
    fontSize: 12,
    fontStyle: "italic",
  },
  bodyItalicBold: {
    fontFamily: "Poppins",
    fontSize: 14,
    fontStyle: "italic",
    fontWeight: "bold",
  },
  bodyBold: {
    fontFamily: "Poppins",
    fontSize: 15,
    fontWeight: "bold",
  },
  bodyWhite: {
    fontFamily: "Poppins",
    fontWeight: "300",
    color: kColors.white,
    fontSize: 14,
  },
  bodyBlack: {
    fontFamily: "Poppins",
    fontWeight: "300",
    fontSize: 14,
  },
  bodyMedium: {
    fontFamily: "Poppins",
    fontSize: 14,
    fontWeight: "500",
  },
  bodyLight: {
    fontFamily: "Poppins",
    fontSize: 14,
    fontWeight: "300",
  },
  clickable: {
    fontSize: 15,
    textDecorationLine: "underline",
  },
  marginHeader: {
    fontSize: 20,
    fontWeight: "bold",
  },
  profileHeader: {
    fontSize: 22,
    fontWeight: "500",
  },
  formLegend: {
    fontSize: 14,
    fontWeight: "600",
  },
  buttonText: {
    color: kColors.white,
    fontSize: 14,
    fontWeight: "600",
  },
  menuTitle: {
    fontSize: 16,
    fontFamily: "Poppins",
    fontWeight: "300",
  },
  menuTitleBold: {
    fontSize: 16,
    fontFamily: "Poppins",
    fontWeight: "bold",
  },
  pageTitle: {
    fontSize: 36,
    fontFamily: "Poppins",
    fontWeight: "300",
  },
  subHeader: {
    fontSize: 16,
    fontFamily: "Poppins",
    fontWeight: "400",
  },
  facet: {
    fontSize: 16,
    fontFamily: "Poppins",
    fontWeight: "500",
  },
  facetSelected: {
    fontSize: 16,
    fontFamily: "Poppins",
    fontWeight: "700",
  },
  poppinsLight: {
    fontSize: 14,
    fontFamily: "Poppins",
    fontWeight: "300",
  },
  poppins400: {
    fontSize: 14,
    fontFamily: "Poppins",
    fontWeight: "400",
  },
  poppinsRegular: {
    fontSize: 14,
    fontFamily: "Poppins",
    fontWeight: "500",
  },
  poppinsBold: {
    fontSize: 14,
    fontFamily: "Poppins",
    fontWeight: "700",
  },
  poppinsSmallLight: {
    fontSize: 12,
    fontFamily: "Poppins",
    fontWeight: "300",
  },
  poppinsSmallRegular: {
    fontSize: 12,
    fontFamily: "Poppins",
    fontWeight: "500",
  },
  poppinsSmallBold: {
    fontSize: 12,
    fontFamily: "Poppins",
    fontWeight: "700",
  },
  poppinsExtraSmall: {
    fontSize: 10,
    fontFamily: "Poppins",
    fontWeight: "500",
  },
  poppinsLargeLight: {
    fontSize: 20,
    fontFamily: "Poppins",
    fontWeight: "300",
  },
  // New Convention
  H1: {
    fontFamily: "Raleway",
    fontWeight: "500",
    fontSize: 36,
  },
  H1_Phone: {
    fontFamily: "Raleway",
    fontWeight: "500",
    fontSize: 28,
  },
  H2: {
    fontFamily: "Poppins",
    fontWeight: "300",
    fontSize: 20,
    lineHeight: 40,
  },
  H3_Light: {
    fontFamily: "Poppins",
    fontWeight: "300",
    fontSize: 16,
  },
  H3: {
    fontFamily: "Poppins",
    fontWeight: "500",
    fontSize: 16,
  },
  H3_Selected: {
    fontFamily: "Poppins",
    fontWeight: "700",
    fontSize: 16,
  },
  H3_AllCaps: {
    fontFamily: "Poppins",
    fontWeight: "500",
    fontSize: 16,
    letterSpacing: 0.1,
    textTransform: "uppercase",
  },
  H4: {
    fontFamily: "Poppins",
    fontWeight: "300",
    fontSize: 14,
    lineHeight: 30,
  },
  H4_Selected: {
    fontFamily: "Poppins",
    fontWeight: "600",
    fontSize: 14,
    lineHeight: 30,
  },
  FacetCount: {
    fontFamily: "Poppins",
    fontWeight: "300",
    fontSize: 14,
  },
  FinePrintText: {
    fontFamily: "Poppins",
    fontWeight: "300",
    fontSize: 12,
  },
  InformationText: {
    fontFamily: "Poppins",
    fontWeight: "500",
    fontSize: 12,
    letterSpacing: 0.1,
  },
  SecondaryCTA: {
    fontFamily: "Poppins",
    fontWeight: "600",
    fontSize: 12,
    letterSpacing: 0.1,
  },
  ButtonText: {
    fontFamily: "Raleway",
    fontWeight: "600",
    fontSize: 14,
    letterSpacing: 0.06,
  },
  AboutBrandHeader: {
    fontFamily: "Raleway",
    fontWeight: "400",
    fontSize: 12,
    letterSpacing: 0.06,
  },
  AboutBrandHeaderSmallBrandName: {
    fontFamily: "Raleway",
    fontWeight: "400",
    fontSize: 28,
  },
  AboutBrandHeaderSmallLocation: {
    fontFamily: "Raleway",
    fontWeight: "400",
    fontSize: 14,
  },
};

type tKFonts = {
  [P in keyof typeof kFontsObj]: TextStyle;
};

// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const kFonts: tKFonts = kFontsObj as tKFonts;

export const fonts = StyleSheet.create({
  // New Convention
  H1_BrandDark: {
    ...kFonts.H1,
    color: kColors.brandDark,
  },
  H1_Phone_BrandDark: {
    ...kFonts.H1_Phone,
    color: kColors.brandDark,
  },
  H1_DarkGray: {
    ...kFonts.H1,
    color: kColors.darkGray,
    lineHeight: 46,
  },
  H2_BrandDark: {
    ...kFonts.H2,
    color: kColors.brandDark,
  },
  H3_Light_Black: {
    ...kFonts.H3_Light,
    color: kColors.brandDark,
  },
  H3_Black: {
    ...kFonts.H3,
    color: kColors.black,
  },
  H3_BrandDark: {
    ...kFonts.H3,
    color: kColors.brandDark,
  },
  H3_DarkGray: {
    ...kFonts.H3,
    color: kColors.darkGray,
    lineHeight: 30,
  },
  H3_Selected_Black: {
    ...kFonts.H3_Selected,
    color: kColors.brandDark,
  },
  H3_AllCaps_BrandDark: {
    ...kFonts.H3_AllCaps,
    color: kColors.brandDark,
  },
  H3_AllCaps_BrandDarkGreen: {
    ...kFonts.H3_AllCaps,
    color: kColors.brandDarkGreen,
  },
  H4_BrandDark: {
    ...kFonts.H4,
    color: kColors.brandDark,
  },
  H4_Selected_BrandDark: {
    ...kFonts.H4_Selected,
    color: kColors.brandDark,
    justifyContent: "center",
  },
  H4_Black: {
    ...kFonts.H4,
    color: kColors.black,
  },
  H4_Selected_Black: {
    ...kFonts.H4_Selected,
    color: kColors.black,
  },
  InformationText_White: {
    ...kFonts.InformationText,
    color: kColors.white,
  },
  bodyBlack: {
    ...kFonts.bodyBlack,
  },
  InformationText_BrandDark: {
    ...kFonts.InformationText,
    color: kColors.brandDark,
  },
  InformationHeader_BrandDarkGreen: {
    ...kFonts.AboutBrandHeader,
    color: kColors.brandDarkGreen,
  },
  SecondaryCTA_BrandDark: {
    ...kFonts.SecondaryCTA,
    color: kColors.brandDark,
  },

  FacetCount_Black: {
    ...kFonts.FacetCount,
    color: kColors.brandDark,
  },
  FinePrintText_Black: {
    ...kFonts.FinePrintText,
    color: kColors.black,
  },
  ButtonText_BrandDark: {
    ...kFonts.ButtonText,
    color: kColors.brandDark,
  },
  ButtonText_White: {
    ...kFonts.ButtonText,
    color: kColors.white,
  },
  AboutBrandHeaderText: {
    ...kFonts.AboutBrandHeader,
    color: kColors.brandDark,
  },
  AboutBrandHeaderSmallBrandName: {
    ...kFonts.AboutBrandHeaderSmallBrandName,
    color: kColors.white,
  },
  AboutBrandHeaderSmallLocation: {
    ...kFonts.AboutBrandHeaderSmallLocation,
    color: kColors.white,
  },
  ErrorSmall: {
    ...kFonts.bodySmall,
    color: kColors.red,
    letterSpacing: 1,
  },
});
